import { Injectable } from "@angular/core"

@Injectable()
export class StorageService {

    constructor() { }

    set(key, value) {
        window.localStorage[key] = value
        return this
    }
    get(key, defaultValue = null) {
        return window.localStorage[key] || defaultValue
    }
    remove(key) {
        window.localStorage.removeItem(key)
        return this
    }
    getObject(key) {
        return JSON.parse(atob(window.localStorage.getItem(key)))
    }
    setObject(key, value) {
        window.localStorage[key] = btoa(JSON.stringify(value))
        return this
    }


}
